import { DriverStepConfig } from "../steps";

/**
 * Вступление, приветствие к экскурсии
 */
export const baseGuide: DriverStepConfig[] = [
    {
    element: 'missing-element', // По центру экрана и затемняем фон
    popover: {
        title: 'Добро пожаловать в приложение Geo-Glass-App',
        description: `
                Сейчас мы проведем для вас краткую инструкцию по работе с приложением.
                В нем вы изучите порядок действий и основы работы в приложении`,
        side: "over", // По центру экрана
        align: 'center', // По центру экрана
        showButtons: ['next', 'close'] as any,
        nextBtnText: 'Далее'
    }
},
{
    element: '.top-bar', 
    popover: {
        title: 'Папки и датчики.',
        description: `
                Для начала следует нажать на выпадающий список "Папка" и выбрать одну из предложенных, либо создать новую папку.
                После чего из выбранной папки можно выбрать интересующий датчик, либо создать новый.`,
        side: "top",
        align: 'center',
        showButtons: ['next', 'close'] as any,
        nextBtnText: 'Далее'
    }
},
{
    element: '.page-switcher', 
    popover: {
        title: 'Режимы карты.',
        description: `
                Веб-приложение поддерживает несколько режимов карты: "Обычная" отображает классическую 2D карту со спутника,
                 "3D" - карта со спутника с ландшафтом, "3D Offline" для работы без подключения к интернету,
                 "Рельеф" - карта рельефа местности.`,
        side: "top",
        align: 'center',
        showButtons: ['next', 'close'] as any,
        nextBtnText: 'Далее'
    }
},
{
    element: '.bottom-bar', 
    popover: {
        title: 'Создание датчика.',
        description: `
                Для создания датчика следует ввести его координаты в поля "Широта", "Долгота" и "Азимут",
                либо выбрать местоположение на карте и указать направление. Первые кнопки отвечают за рассчет, перерасчет и сохранение датчика в системе.
                Для корректной работы следует сначала сохранить датчик, а после уже рассчитывать графики! Последние кнопки отвечают за центрирование карты относительно датчика
                и указания ширины конуса соответственно.`,
        side: "top",
        align: 'center',
        showButtons: ['next', 'close'] as any,
        nextBtnText: 'Далее'
    }
},
{
    element: '.bottom-right-btns', 
    popover: {
        title: 'Кнопки "Графики" и "Настройки".',
        description: `
                Кнопка "Графики", при нажатии на нее, открывает окно выбора датчиков для отображения интересующих графиков.
                Кнопка "Настройки" предоставляет возможность настраивать будущие рассчеты.`,
        side: "top",
        align: 'center',
        showButtons: ['next', 'close'] as any,
        nextBtnText: 'Далее'
    }
},
{
        element: 'missing-element',
        popover: {
            title: 'Спасибо за внимание!',
            description: `
                Вы успешно ознакомились с основами работы в приложении Geo-Glass-App.
                Теперь вы готовы к самостоятельной работе. Удачи!`,
            side: "over",
            align: 'center',
            showButtons: ['next', 'close'] as any,
            nextBtnText: 'Понятно'
        }
    }
]